var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4h8v7H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14h10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14v6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11l-1 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11l1 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.703389f08c9c3b22e1cc8de2e43a6eef.svg";
export { ForwardRef as ReactComponent };